import React from "react";
import styled from "styled-components";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  return (
    <Container id="Home">
      <ContentWrapper>
        <Title>Olá, eu sou Mateus Henrique Martins!</Title>
        <Subtitle>Desenvolvedor Frontend | Apaixonado por Tecnologia</Subtitle>
        <ButtonContainer>
          <ProjectLink to="/projects">
            <FaArrowRight size={16} />
            <span>Veja meus Principais Projetos</span>
          </ProjectLink>
          <ProjectLink to="/about" secondary>
            <FaArrowRight size={16} />
            <span>Sobre Mim</span>
          </ProjectLink>
          <ProjectLink to="/chatBot">
            <FaArrowRight size={16} />
            <span>ChatBot</span>
          </ProjectLink>
          <ProjectLink to="/miniGame" secondary>
            <FaArrowRight size={16} />
            <span>Minigame</span>
          </ProjectLink>
          <DownloadLink 
            href="https://online.fliphtml5.com/xviwx/tvgq/" 
            target="_blank" 
            rel="noopener noreferrer">
            <FaArrowRight size={16} />
            <span>Veja meu Currículo</span>
          </DownloadLink>
          <ProjectLink to="/contact" secondary>
            <FaArrowRight size={16} />
            <span>Entre em contato</span>
          </ProjectLink>
        </ButtonContainer>
      </ContentWrapper>
    </Container>
  );
};

export default Home;

/* Estilos com styled-components */

const Container = styled.div`
  padding: 3rem 1rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  font-family: "Poppins", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  
  @media (max-width: 480px) {
    padding: 2rem 0.5rem;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  background: rgba(255, 255, 255, 0.1);
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    padding: 2rem;
  }
  
  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const Title = styled.h1`
  font-size: 2.8rem;
  margin-bottom: 1rem;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 2.3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 400;
  opacity: 0.95;
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.1rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
`;

const buttonStyles = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: transform 0.3s ease, background 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid transparent;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  svg {
    margin-bottom: 2px;
  }

  /* No celular, força os botões terem largura completa */
  @media (max-width: 480px) {
    width: 100%;
  }
`;

const ProjectLink = styled(Link)<{ secondary?: boolean }>`
  ${buttonStyles}
  background: ${({ secondary }) => (secondary ? "#ffa726" : "#ffffff")};
  color: ${({ secondary }) => (secondary ? "#ffffff" : "#2a5298")};

  &:hover {
    background: ${({ secondary }) => (secondary ? "#ff9800" : "#dfe6e9")};
  }
`;

const DownloadLink = styled.a`
  ${buttonStyles}
  background: #ffffff;
  color: #2a5298;

  &:hover {
    background: #dfe6e9;
  }
`;
